import { theme } from "@src/theme";
import { action, makeObservable, observable, reaction } from "mobx";

export type ScreenType = {
  readonly isMobile: boolean;
  readonly isTablet: boolean;
  readonly isDesktop: boolean;
};

// One pair of media query listeners for the whole app, instead of a set per `useScreenType` caller
export class ScreenTypeState {
  @observable.ref value: ScreenType;

  private tabletQuery = window.matchMedia(
    `(min-width: ${theme.breakpoints.md})`,
  );
  private desktopQuery = window.matchMedia(
    `(min-width: ${theme.breakpoints.lg})`,
  );

  constructor() {
    makeObservable(this);
    this.value = this.read();
    this.tabletQuery.addEventListener("change", this.update);
    this.desktopQuery.addEventListener("change", this.update);
  }

  @action.bound private update(): void {
    this.value = this.read();
  }

  private read(): ScreenType {
    const isDesktop = this.desktopQuery.matches;
    const isTablet = this.tabletQuery.matches && !isDesktop;

    return { isMobile: !isTablet && !isDesktop, isTablet, isDesktop };
  }

  readonly subscribe = (onChange: () => void): (() => void) =>
    reaction(() => this.value, onChange);

  readonly getSnapshot = (): ScreenType => this.value;
}
